/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { LoadingCapabilitiesAvailability } from "./LoadingCapabilitiesAvailability";
import {
  LoadingCapabilitiesAvailabilityFromJSON,
  LoadingCapabilitiesAvailabilityFromJSONTyped,
  LoadingCapabilitiesAvailabilityToJSON,
  LoadingCapabilitiesAvailabilityToJSONTyped,
} from "./LoadingCapabilitiesAvailability";
import type { LocationContext } from "./LocationContext";
import {
  LocationContextFromJSON,
  LocationContextFromJSONTyped,
  LocationContextToJSON,
  LocationContextToJSONTyped,
} from "./LocationContext";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface SavedLocation
 */
export interface SavedLocation {
  /**
   *
   * @type {string}
   * @memberof SavedLocation
   */
  savedLocationId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SavedLocation
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof SavedLocation
   */
  companyId?: string;
  /**
   *
   * @type {Location}
   * @memberof SavedLocation
   */
  location?: Location;
  /**
   *
   * @type {LocationContext}
   * @memberof SavedLocation
   */
  locationContext?: LocationContext;
  /**
   *
   * @type {string}
   * @memberof SavedLocation
   */
  defaultSavedContactId?: string;
  /**
   *
   * @type {boolean}
   * @memberof SavedLocation
   */
  isFavourite?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SavedLocation
   */
  isBranch?: boolean;
  /**
   *
   * @type {LoadingCapabilitiesAvailability}
   * @memberof SavedLocation
   */
  locationHasDock?: LoadingCapabilitiesAvailability;
  /**
   *
   * @type {LoadingCapabilitiesAvailability}
   * @memberof SavedLocation
   */
  locationHasForklift?: LoadingCapabilitiesAvailability;
}

/**
 * Check if a given object implements the SavedLocation interface.
 */
export function instanceOfSavedLocation(value: object): value is SavedLocation {
  return true;
}

export function SavedLocationFromJSON(json: any): SavedLocation {
  return SavedLocationFromJSONTyped(json, false);
}

export function SavedLocationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SavedLocation {
  if (json == null) {
    return json;
  }
  return {
    savedLocationId:
      json["savedLocationId"] == null ? undefined : json["savedLocationId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    location:
      json["location"] == null ? undefined : LocationFromJSON(json["location"]),
    locationContext:
      json["locationContext"] == null
        ? undefined
        : LocationContextFromJSON(json["locationContext"]),
    defaultSavedContactId:
      json["defaultSavedContactId"] == null
        ? undefined
        : json["defaultSavedContactId"],
    isFavourite: json["isFavourite"] == null ? undefined : json["isFavourite"],
    isBranch: json["isBranch"] == null ? undefined : json["isBranch"],
    locationHasDock:
      json["locationHasDock"] == null
        ? undefined
        : LoadingCapabilitiesAvailabilityFromJSON(json["locationHasDock"]),
    locationHasForklift:
      json["locationHasForklift"] == null
        ? undefined
        : LoadingCapabilitiesAvailabilityFromJSON(json["locationHasForklift"]),
  };
}

export function SavedLocationToJSON(json: any): SavedLocation {
  return SavedLocationToJSONTyped(json, false);
}

export function SavedLocationToJSONTyped(
  value?: SavedLocation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    savedLocationId: value["savedLocationId"],
    createdAt: value["createdAt"],
    companyId: value["companyId"],
    location: LocationToJSON(value["location"]),
    locationContext: LocationContextToJSON(value["locationContext"]),
    defaultSavedContactId: value["defaultSavedContactId"],
    isFavourite: value["isFavourite"],
    isBranch: value["isBranch"],
    locationHasDock: LoadingCapabilitiesAvailabilityToJSON(
      value["locationHasDock"],
    ),
    locationHasForklift: LoadingCapabilitiesAvailabilityToJSON(
      value["locationHasForklift"],
    ),
  };
}
